<template>
  <div class="create_wrapper fadeIn">
    <!-- Start Breadcrumb -->
    <Breadcrumb :items="items" />
    <!-- End Breadcrumb -->

    <div class="custom_card">
      <div class="card-header">
        <h4 class="card-title">{{ $t("addNew") }}</h4>
      </div>

      <!-- ==== Start Form ==== -->
      <form @submit.prevent="validateCreateForm">
        <div class="container">
          <div class="row justify-content-between">
            <div class="col-lg-6 py-0">
              <div class="input_wrapper top_label">
                <input
                  @keypress="isArabic"
                  type="text"
                  class="form-control"
                  @input="helper_checkIfInputIsEmpty"
                  v-model.trim="data.ar.name"
                />
                <label for="name_input" class="form-label">
                  {{ $t("forms.labels.name_ar") }}
                </label>
              </div>
            </div>

            <div class="col-lg-6 py-0">
              <div class="input_wrapper top_label">
                <input
                  @keypress="isEnglish"
                  type="text"
                  class="form-control"
                  @input="helper_checkIfInputIsEmpty"
                  v-model.trim="data.en.name"
                />
                <label for="name_input" class="form-label">
                  {{ $t("forms.labels.name_en") }}
                </label>
              </div>
            </div>
            <!-- End:: En title -->
            <div class="col-lg-6 py-0" v-if="false">
              <div class="input_wrapper top_label">
                <label for="textarea_1" class="form-label">
                  {{ $t("forms.labels.desc_ar") }}
                </label>

                <ckeditor v-model="data.ar.desc" class="mx-auto" />
                <!-- <textarea
                  class="form-control"
                  rows="5"
                  v-model="data.ar.desc"
                ></textarea> -->
              </div>
            </div>
            <div class="col-lg-6 py-0" v-if="false">
              <div class="input_wrapper top_label">
                <label for="textarea_1" class="form-label">
                  {{ $t("forms.labels.desc_en") }}
                </label>

                <ckeditor v-model="data.en.desc" class="mx-auto" />
                <!-- <textarea
                  class="form-control"
                  rows="5"
                  v-model="data.ar.desc"
                ></textarea> -->
              </div>
            </div>

            <div class="col-lg-6 py-0">
              <div class="input_wrapper top_label">
                <label class="form-label">
                  {{ $t("forms.labels.reason_type") }}
                </label>
                <multiselect
                  v-model="data.reason_type"
                  :options="reason_types"
                  label="name"
                  track-by="id"
                  placeholder=" "
                  :searchable="true"
                  :allow-empty="true"
                  :show-labels="false"
                ></multiselect>
              </div>
            </div>
            <div class="col-lg-6 py-0">
              <div class="input_wrapper top_label">
                <label class="form-label">
                  {{ $t("forms.labels.user_type") }}
                </label>
                <multiselect
                  v-model="data.user_type"
                  label="name"
                  track-by="id"
                  placeholder=" "
                  :searchable="true"
                  :allow-empty="true"
                  :show-labels="false"
                  :options="
                    data.reason_type?.id != 'review'
                      ? user_types
                      : user_types.filter((item) => item.id != 'restaurant')
                  "
                ></multiselect>
              </div>
            </div>
          </div>
        </div>

        <div class="buttons_wrapper">
          <button class="button_style_1" :disabled="btnIsLoading">
            {{ $t("forms.submit") }}
            <span class="btn_loader" v-if="btnIsLoading"></span>
          </button>
        </div>
      </form>
      <!-- ==== End Form ==== -->
    </div>
  </div>
</template>

<script>
export default {
  name: "Create",
  props: ["id"],

  data() {
    return {
      loading: false,
      // ========== Breadcrumbs
      items: [
        {
          text: this.$t("breadcrumb.mainPage"),
          disabled: false,
          href: "/",
        },
        {
          text: this.$t("breadcrumb.cancel_reasons.title"),
          disabled: false,
          href: "/cancel_reasons/show-all",
        },
        {
          text: this.$t("breadcrumb.cancel_reasons.add"),
          disabled: true,
          href: "",
        },
      ],

      // ========== Loading
      btnIsLoading: false,

      // ========== create_data
      data: {
        ar: {
          name: null,
          desc: null,
        },
        en: {
          name: null,
          desc: null,
        },
        user_type: null,
        reason_type: null,
      },
      reason_types: [
        {
          id: "reject",
          name: this.$t("reject"),
        },
        {
          id: "cancel",
          name: this.$t("cancel"),
        },
        {
          id: "review",
          name: this.$t("review"),
        },
        {
          id: "fine",
          name: this.$t("fine"),
        },
        {
          id: "return",
          name: this.$t("return"),
        },
      ],
      user_types: [
        {
          id: "driver",
          name: this.$t("driver"),
        },
        {
          id: "client",
          name: this.$t("client"),
        },
        {
          id: "restaurant",
          name: this.$t("resturant"),
        },
        {
          id: "admin",
          name: this.$t("admin"),
        },
      ],
    };
  },

  methods: {
    // Validate Data
    validateCreateForm() {
      this.btnIsLoading = true;

      if (!this.data.ar.name) {
        this.$iziToast.error({
          timeout: 2000,
          message: this.$t("forms.validation.name_ar"),
          position: "bottomRight",
        });
        this.btnIsLoading = false;
        return;
      } else if (!this.data.en.name) {
        this.$iziToast.error({
          timeout: 2000,
          message: this.$t("forms.validation.name_en"),
          position: "bottomRight",
        });
        this.btnIsLoading = false;
        return;
      } else if (!this.data.reason_type) {
        this.$iziToast.error({
          timeout: 2000,
          message: this.$t("forms.validation.reason_type"),
          position: "bottomRight",
        });
        this.btnIsLoading = false;
        return;
      } else if (!this.data.user_type) {
        this.$iziToast.error({
          timeout: 2000,
          message: this.$t("forms.validation.user_type"),
          position: "bottomRight",
        });
        this.btnIsLoading = false;
        return;
      } else {
        this.submitData();
        return;
      }
    },

    // Submit Data
    submitData() {
      this.btnIsLoading = true;

      const submit_data = new FormData();

      submit_data.append("ar[name]", this.data.ar.name);
      // submit_data.append("ar[description]", this.data.ar.desc);

      submit_data.append("en[name]", this.data.en.name);
      // submit_data.append("en[description]", this.data.en.desc);

      if (this.data.reason_type) {
        submit_data.append("user_type", this.data.user_type?.id);
      }

      submit_data.append("reason_type", this.data.reason_type.id);

      this.$axios({
        method: "POST",
        url: "cancel_reason",
        data: submit_data,
      })
        .then(() => {
          this.$iziToast.success({
            timeout: 2000,
            message: this.$t("addSuccess"),
            position: "bottomRight",
          });

          this.$router.push({ path: "/cancel_reason/show-all" });

          this.btnIsLoading = false;
        })
        .catch((err) => {
          this.$iziToast.error({
            timeout: 2000,
            message: err.response.data.message,
            position: "bottomRight",
          });
          this.btnIsLoading = false;
        });
    },
  },
};
</script>
